import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { OnmaxContext } from "../OnmaxContext";

export default function LoginChangePassword() {
  // const username = localStorage.getItem("username");
  const navigate = useNavigate();
  const { toastSuccess, toastError,formatAddress } = useContext(OnmaxContext);

  const [data, setData] = useState({});
  const [username, setUsername] = useState("");
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  const [oldPassword, setOldPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const maskEmail = (email) => {
  if (!email) return '';

  const [name, domain] = email.split('@');

  if (name.length <= 4) return email; // fallback

  const start = name.slice(0, 3);
  const end = name.slice(-2);

  return `${start}****${end}@${domain}`;
};

  const getData = async () => {
    if (!username) return;
    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "profile",
        username,
        key: process.env.REACT_APP_KEY,
      });
      if (!res.data?.error) {
        setData(res.data.data);
      }
    } catch (err) { console.error(err); }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username]);

  const sendOtp = async (e) => {
    e.preventDefault();
    if (!oldPassword) return toastError("Enter current password");
    setLoading(true);

    const userRes = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
      method: "user",
      submethod: "profile",
      username,
      key: process.env.REACT_APP_KEY,
    });
    // console.log('userRes.data',userRes.data.data.password);

    if (userRes.data?.error || !userRes.data?.data) {
      setLoading(false);
      return toastError(userRes.data?.error || "User not found");
    }

    if(userRes.data.data.password !== oldPassword) {
      setLoading(false);
      return toastError("Invalid current password");
    }

    const userData = userRes.data.data;
    setData(userData);

    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "send",
        email: data.email,
        username,
        password: oldPassword,
        key: process.env.REACT_APP_KEY,
      });
      if (res.data?.resCode === 200) {
        toastSuccess("OTP sent to your email");
        setStep(2);
      } else {
        toastError(res.data?.message || "Invalid password");
      }
    } catch (err) {
      toastError("Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async () => {
    if (otp.length !== 6) return toastError("Enter 6-digit OTP");
    setLoading(true);
    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "verifyemail",
        email: data.email,
        otp,
        key: process.env.REACT_APP_KEY,
      });
      if (res.data?.resCode === 200) {
        toastSuccess("OTP verified");
        setStep(3);
      } else {
        toastError(res.data?.message || "Invalid OTP");
      }
    } catch {
      toastError("Verification failed");
    } finally {
      setLoading(false);
    }
  };

  const updatePassword = async () => {
    if (!newPassword) return toastError("Enter new password");
    setLoading(true);
    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "updateps",
        username,
        password: newPassword,
        isAdmin: false,
        key: process.env.REACT_APP_KEY,
      });
      if (res.data?.resCode === 200) {
        toastSuccess("Password changed successfully");
        navigate("/");
      } else {
        toastError(res.data?.error || "Failed to update password");
      }
    } catch {
      toastError("Server error");
    } finally {
      setLoading(false);
    }
  };

  const customStyles = `
    .ai-auth-container {
        min-height: calc(100vh - 88px);
        background: #f1f5f9;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
    }
    
    .ai-auth-card {
        background: #ffffff;
        border-radius: 20px;
        padding: 40px;
        width: 100%;
        max-width: 480px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(0, 0, 0, 0.05);
    }

    .ai-title { color: #1a2234; text-align: center; font-size: 26px; font-weight: 800; margin-bottom: 8px; }
    .ai-subtitle { color: #64748b; text-align: center; font-size: 14px; margin-bottom: 32px; }

    .ai-step-indicator { display: flex; gap: 8px; margin-bottom: 30px; }
    .ai-step-dot { flex: 1; height: 4px; border-radius: 4px; background: #e2e8f0; }
    .ai-step-dot.active { background: #006fe3; box-shadow: 0 0 10px rgba(0, 111, 227, 0.3); }

    .db-input-wrapper {
      background: rgba(238, 242, 246, 0.5); 
      border-radius: 12px; 
      padding: 16px; 
      border: 1px solid rgba(0, 0, 0, 0.05);
      box-shadow: 1px 15px 15px -10px #bfc9d8;
      display: flex; align-items: center; gap: 12px;
      margin-bottom: 24px;
    }

    .db-input {
      background: transparent !important; border: none !important; outline: none !important; width: 100%; font-weight: 700; color: #000000 !important; font-size: 15px;
    }

    .db-modern-btn {
      background: linear-gradient(135deg, #006fe3, #005bb5);
      color: #fff; border: none; padding: 16px; border-radius: 12px;
      font-weight: 700; width: 100%; font-size: 16px;
      box-shadow: 0 4px 15px rgba(0, 111, 227, 0.3); transition: 0.3s;
    }
    .db-modern-btn.green { background: linear-gradient(135deg, #10b981, #059669); box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3); }
    .db-modern-btn.orange { background: linear-gradient(135deg, #f59e0b, #d97706); box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3); }
    .db-modern-btn:hover { transform: translateY(-2px); }
  `;

  return (
    <>
      <style>{customStyles}</style>
      <div className="body-bg">
        {/* <Sidebar />
        <Header /> */}
        <section className="">
          <div className="ai-auth-container vh-100">
            <div className="ai-auth-card">
              <h2 className="ai-title">Change Password</h2>
              <p className="ai-subtitle">Update your login credentials securely</p>

              <div className="ai-step-indicator">
                <div className={`ai-step-dot ${step >= 1 ? 'active' : ''}`}></div>
                <div className={`ai-step-dot ${step >= 2 ? 'active' : ''}`}></div>
                <div className={`ai-step-dot ${step >= 3 ? 'active' : ''}`}></div>
              </div>

              {step === 1 && (
                <form onSubmit={sendOtp}>
                  <div className="db-input-wrapper">

                    <i className="fa fa-user" style={{ color: '#006fe3' }}></i>
                    <input
                      type="text"
                      className="db-input"
                      placeholder="Username                                              "
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                    />
                  </div>
                  <div className="db-input-wrapper">

                    <i className="fa fa-key" style={{ color: '#006fe3' }}></i>
                    <input
                      type="password"
                      className="db-input"
                      placeholder="Current Password"
                      value={oldPassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                      required
                    />
                  </div>
                  <button className="db-modern-btn" disabled={loading}>
                    {loading ? "Checking..." : "Verify Identity"}
                  </button>
                </form>
              )}

              {step === 2 && (
                <div>
                  <p className="text-center text-secondary small mb-3">OTP sent to <b>{maskEmail(data.email)}</b></p>
                  <div className="db-input-wrapper">
                    <input
                      type="text"
                      className="db-input text-center fs-4"
                      placeholder="Enter 6-digit OTP"
                      maxLength={6}
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </div>
                  <button className="db-modern-btn green" onClick={verifyOtp} disabled={loading}>
                    {loading ? "Verifying..." : "Verify OTP"}
                  </button>
                </div>
              )}

              {step === 3 && (
                <div>
                  <div className="db-input-wrapper">
                    <i className="fa fa-lock" style={{ color: '#d97706' }}></i>
                    <input
                      type="text"
                      className="db-input"
                      placeholder="Enter New Password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                  </div>
                  <button className="db-modern-btn orange" onClick={updatePassword} disabled={loading}>
                    {loading ? "Updating..." : "Confirm New Password"}
                  </button>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
